import { useState, useEffect } from 'react';
import { Container, IndicatorSatus, Options } from './styled';
import { BiChevronDown, BiChevronUp } from 'react-icons/bi';
import { useAuth } from '../../contexts/auth';
import { putStatusUser } from '../../service/serviceChat/userConfigService';

export const StatusUser = () => {

    const { statusUserSystem, onSetStatusUserSystem } = useAuth();
    const [openOpitions, setOpenOpitions] = useState(false);

    const registerStatusByLogin = async () => {
        return await putStatusUser(statusUserSystem);
    };
    useEffect(() => {
        registerStatusByLogin();
    }, []);

    async function handSelectStatus(newStatus) {
        const res = await putStatusUser(newStatus);
        if (!res) return;
        onSetStatusUserSystem(newStatus);
        setOpenOpitions(false);
    };

    return (
        <>
            <Container onClick={() => setOpenOpitions(!openOpitions)}>
                <div className='status__'>
                    <IndicatorSatus status={statusUserSystem} />
                    <span>
                        {statusUserSystem[0].toUpperCase() + statusUserSystem.slice(1).toLowerCase()}
                    </span>
                </div>
                <div className='Down'>
                    {openOpitions ? <BiChevronUp /> : <BiChevronDown />}
                </div>
            </Container>
            <Options isOpen={openOpitions}>
                <li onClick={() => handSelectStatus('ONLINE')}>
                    <IndicatorSatus status={'ONLINE'} />
                    Online
                </li>
                <li onClick={() => handSelectStatus('PAUSA')}>
                    <IndicatorSatus status={'PAUSA'} />
                    Pausa
                </li>
                <li onClick={() => handSelectStatus('OFFLINE')}>
                    <IndicatorSatus status={'OFFLINE'} />
                    Offline
                </li>
            </Options>
        </>
    );

};
